import React from 'react';
import { IOpeningTime } from '../../../interfaces/professional/Professional';
import WorkingDay from './WorkingDay/WorkingDay';
import * as classes from './WorkingHours.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import cn from 'classnames';

interface Props extends IOpeningTime {
  isTransparentBg?: boolean;
  isBolderTitle?: boolean;
}

const WorkingHours = ({ monday, saturday, sunday, thursday, tuesday, wednesday, friday, isTransparentBg, isBolderTitle }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={cn(classes.wrapper, isTransparentBg && classes.transparentBg)}>
      <div className={cn(classes.title, isBolderTitle && classes.bolder)}>{t('getInTouch.heroSection.availability.title')}</div>
      <WorkingDay {...monday} dayOfWeek={t('getInTouch.heroSection.availability.monday')} />
      <WorkingDay {...tuesday} dayOfWeek={t('getInTouch.heroSection.availability.tuesday')} />
      <WorkingDay {...wednesday} dayOfWeek={t('getInTouch.heroSection.availability.wednesday')} />
      <WorkingDay {...thursday} dayOfWeek={t('getInTouch.heroSection.availability.thursday')} />
      <WorkingDay {...friday} dayOfWeek={t('getInTouch.heroSection.availability.friday')} />
      <WorkingDay {...saturday} dayOfWeek={t('getInTouch.heroSection.availability.saturday')} />
      <WorkingDay {...sunday} dayOfWeek={t('getInTouch.heroSection.availability.sunday')} />
    </div>
  );
};

export default WorkingHours;
